export default __webpack_public_path__ + "static/404-26fbd1ade265bb37726bc1f89afa68f9.gif";